import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/cadastro/')({
  component: lazyRouteComponent(
    () => import('@/features/cadastro/components/cadastro-page'),
    'CadastroPage'
  ),
})
